

<template>
    <div>
        <a href="#" class="has__tooltip" v-on:click.stop="toogle">
            <div class="gheom__kebab">
                <figure></figure>
                <figure class="middle"></figure>
                <figure></figure>
            </div>
        </a>
        <div class="element gheom__card__tooltip" :class="shownClass">

            <div class="tooltip__menu">
                <ul>
                    <slot></slot>
                </ul>
            </div>
        </div>
        <div v-if="visible" class="backdrop" v-on:click.stop="visible=false">

        </div>
    </div>
</template>



<script>
    export default {
        name: "",
        props: [
            ""
        ],
        data(){
            return {
                visible: false
            }
        },
        computed: {
            shownClass: function() {
                let theclass = "";
                (this.visible === true) ? theclass = "tooltip--active" : theclass = "";
                return theclass;
            }
        },
        methods: {
            toogle(){
                this.visible = !this.visible;
            },
            show(){
                this.visible = true;
            },
            hide(){
                this.visible = false;
            },
        }
    }
</script>

<style scoped>
    a {
        padding-left: 5px;
        padding-right: 5px;
    }

    .element {
        z-index: 100;
    }

</style>